import React from 'react';
import Fab from '@mui/material/Fab';
import Tooltip from '@mui/material/Tooltip';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import Box from '@mui/material/Box';
import { WHATSAPP_URL } from '../constants/site';
import { trackEvent } from '../utils/analytics';

const WhatsAppButton = () => (
  <Box
    sx={{
      position: 'fixed',
      bottom: { xs: 16, sm: 24 },
      right: { xs: 16, sm: 24 },
      zIndex: 1100,
    }}
  >
    <Tooltip title="Chatea con nosotros" placement="left">
      <Fab
        color="success"
        aria-label="WhatsApp"
        href={WHATSAPP_URL}
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => trackEvent('cta_click', { location: 'fab', type: 'whatsapp' })}
        sx={{
          width: { xs: 52, sm: 60 },
          height: { xs: 52, sm: 60 },
          boxShadow: '0 8px 28px rgba(37, 211, 102, 0.45)',
          '&:hover': {
            transform: 'scale(1.06)',
            boxShadow: '0 12px 36px rgba(37, 211, 102, 0.5)',
          },
          transition: 'transform 0.2s ease, box-shadow 0.2s ease',
        }}
      >
        <WhatsAppIcon sx={{ fontSize: { xs: 26, sm: 30 } }} />
      </Fab>
    </Tooltip>
  </Box>
);

export default WhatsAppButton;
